export default __webpack_public_path__ + "static/media/mittellanger_bus_cockpit.c4006385.jpg";